$('.site-header__cart').click(function() {
  $('.popup-cart').toggle();
});

$('#scroll-up').click(function() {
  $("html, body").animate({ scrollTop: 0 }, 300);
});

$( window ).on( 'load', function() {
$(window).scroll(function() {
    if ($(this).scrollTop() > 100) {
        $('#scroll-up').show();
    } else {
        $('#scroll-up').hide();
    }
});
if ($('.sticky').length && $(window).width() > 749) {
  const stickyWidth = $('.sticky').parent().width();
  const stickyTop = $('.sticky').offset().top;
  const footerTop = $('.main-content').offset().top + $('.main-content').outerHeight(true) - $('.sticky').outerHeight(true);
  
  $(window).scroll(function() {      
    if ($(window).scrollTop() > footerTop - 50) {
        $('.sticky').removeClass('stick');
        $('.sticky').addClass('stick-bottom');
        $('.sticky').css('width', stickyWidth);
    } else if ($(window).scrollTop() > stickyTop - 50) {
        $('.sticky').removeClass('stick-bottom');
        $('.sticky').addClass('stick');
        $('.sticky').css('width', stickyWidth);
    } else {
        $('.sticky').removeClass('stick');
        $('.sticky').removeClass('stick-bottom');
        $('.sticky').css('width', '');
    }
  });
}
});

$(document).ready(function(){
  if( typeof(productOptions ) != "undefined" ){
    for(i=0;i<productOptions.length;i++) {
      let t = $('.single-option-selector:eq('+ i +')')
      .filter(function() {
        return $(this).find('option').length > 1
      });
      t.prepend('<option disabled value="">Select ' + productOptions[i][i] + '</option>');
      if (window.location.href.indexOf("?variant=") <= -1) {
        t.val('')
        .trigger('change');
      }
    }
  }
var stepImg = $("#stepImg");
$(".step_img_thumbnail_container img").hover(function(){
var src = $(this).attr("src");
$(this).parents(".shg-row").find(".step_img_container > img").attr("src",src);
});
stepImg.on("click",function(){
$(this).css("transform","scale(2)");
});
});

var acc = document.getElementsByClassName("accordion");
var i;

for (i = 0; i < acc.length; i++) {
  acc[i].addEventListener("click", function() {
    /* Toggle between adding and removing the "active" class,
    to highlight the button that controls the panel */
    this.classList.toggle("active");

    /* Toggle between hiding and showing the active panel */
    var panel = this.nextElementSibling;
    if (panel.style.display === "block") {
      panel.style.display = "none";
    } else {
      panel.style.display = "block";
    }
  });
}

if ($(window).width() <= 749) {
var acc2 = document.getElementsByClassName("mobile-accordion");
var i;

for (i = 0; i < acc2.length; i++) {
  acc2[i].addEventListener("click", function() {
    this.classList.toggle("mobile-active");
    var panel = this.nextElementSibling;
    if (panel.style.maxHeight) {
      panel.style.maxHeight = null;
    } else {
      panel.style.maxHeight = panel.scrollHeight + "px";
    }
  });
}
}
/*
$('.product-single__thumbnails-product-template').slick({
    slidesToShow: 4,
    slidesToScroll: 3,
    infinite: true,
    prevArrow: '.thumbnails-slider__prev--product-template',
    nextArrow: '.thumbnails-slider__next--product-template'
});
*/